// extracted by css-extract-rspack-plugin
export default {"collectionWrapper":"_2390f471","nullDescription":"_13fa0009","heading":"_9d60361c","items":"_3dc97312"};